module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group d-flex"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesChannel.name),
      expression: "salesChannel.name"
    }],
    staticClass: "w-50",
    attrs: {
      "type": "text",
      "placeholder": "Name here",
      "disabled": _vm.blockNameChange
    },
    domProps: {
      "value": (_vm.salesChannel.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salesChannel, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between mb-2 align-items-center"
  }, [_c('span', {
    staticClass: "fs-small bold"
  }, [_vm._v("Allow to book Extras")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      }
    },
    model: {
      value: (_vm.salesChannel.isAllowedSellComponents),
      callback: function($$v) {
        _vm.$set(_vm.salesChannel, "isAllowedSellComponents", $$v)
      },
      expression: "salesChannel.isAllowedSellComponents"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between mb-2 align-items-center"
  }, [_c('span', {
    staticClass: "fs-small bold",
    class: {
      'opacity-50': _vm.disableTranpsortOption
    }
  }, [_vm._v("Allow to book Transports")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "disabled": _vm.disableTranpsortOption,
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      }
    },
    model: {
      value: (_vm.salesChannel.isAllowedSellTransports),
      callback: function($$v) {
        _vm.$set(_vm.salesChannel, "isAllowedSellTransports", $$v)
      },
      expression: "salesChannel.isAllowedSellTransports"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between mb-2 align-items-center"
  }, [_c('span', {
    staticClass: "fs-small bold"
  }, [_vm._v("Send notification on new booking")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      }
    },
    model: {
      value: (_vm.salesChannel.notificationNewBooking),
      callback: function($$v) {
        _vm.$set(_vm.salesChannel, "notificationNewBooking", $$v)
      },
      expression: "salesChannel.notificationNewBooking"
    }
  })], 1), _vm._v(" "), (_vm.hasInvoiceSystem && _vm.salesChannel.channelType === 101) ? _c('div', {
    staticClass: "d-flex justify-content-between mb-2 align-items-center"
  }, [_c('div', {
    class: {
      'opacity-50': !_vm.salesChannel.notificationFlags.automaticInvoice.canBeEnabled
    }
  }, [_c('span', {
    staticClass: "fs-small bold"
  }, [_vm._v("Automatic invoice")])]), _vm._v(" "), _c('div', [_c('toggle-button', {
    attrs: {
      "value": _vm.salesChannel.notificationFlags.automaticInvoice.state === 1,
      "disabled": !_vm.salesChannel.notificationFlags.automaticInvoice.canBeEnabled,
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      }
    },
    on: {
      "input": function (val) { return _vm.salesChannel.notificationFlags.automaticInvoice.state = val ? 1 : 0; }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showTicketFormatPicker) ? _c('div', {
    staticClass: "d-flex justify-content-between mb-2 align-items-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('v-select', {
    attrs: {
      "options": _vm.getTicketTypes
    },
    on: {
      "input": _vm.ticketTypeChanged
    },
    model: {
      value: (_vm.salesChannel.ticketType_helper_selected),
      callback: function($$v) {
        _vm.$set(_vm.salesChannel, "ticketType_helper_selected", $$v)
      },
      expression: "salesChannel.ticketType_helper_selected"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between mb-2 align-items-center"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('v-select', {
    attrs: {
      "label": "name",
      "options": _vm.originsOptions,
      "reduce": function (origin) { return origin.id; }
    },
    on: {
      "input": _vm.originChanged
    },
    model: {
      value: (_vm.origin),
      callback: function($$v) {
        _vm.origin = $$v
      },
      expression: "origin"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', [_vm._v("Advanced Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('span', {
    staticClass: "fs-small bold"
  }, [_vm._v("Ticket format")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('span', {
    staticClass: "fs-small bold"
  }, [_vm._v("Origins")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-770ba297", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-770ba297"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/salesChannels/salesChannelForm.vue
// module id = 2228
// module chunks = 0